import { ReactNode } from "react";
import styles from "../aic.module.css";
import { AitAddColumnButton } from "./AitAddColumnButton";
import { AitColumnAnnotationButton } from "./AitColumnAnnotationButton";
import { AitColumnTrafficLight } from "./AitColumnTrafficLight";
import { AitRemoveColumnButton } from "./AitRemoveColumnButton";
import { useTableContext } from "./TableContextProvider";

interface AitTopBorderCellProps {
  columnIndex: number;
  originalColumnIndex: number;
  cellid: string;
  columnId: string;
}

/**
 * Render the top border cell which contains column controls and indicators.
 *
 * @param props - Component props
 * @param props.columnIndex - The current display index of the column
 * @param props.originalColumnIndex - The original source index of the column before any reordering
 * @param props.cellid - The cell identifier
 * @param props.columnId - The unique identifier for the column
 */
export const AitTopBorderCell = ({
  columnIndex,
  originalColumnIndex,
  cellid,
  columnId,
}: AitTopBorderCellProps): ReactNode => {
  const { state } = useTableContext();
  const tableData = state?.processedTableData;
  const isColumnRepeat =
    tableData &&
    tableData.columnRepeats &&
    tableData.columnRepeats.length > columnIndex &&
    tableData.columnRepeats[columnIndex].colRepeat !== undefined &&
    (tableData.columnRepeats[columnIndex].isRepeat ||
      tableData.columnRepeats[columnIndex].colRepeat?.match(/^[[\]0,]+$/) === null)
      ? true
      : false;
  const rowHeaderColumns = state?.processedTableData?.rowHeaderColumns ?? 0;
  const maxColumnIndex = (tableData?.bodyData[0].rows[0].cells.length ?? 0) - 1;

  return !tableData ? null : (
    <td
      className={styles.aitCell}
      style={{ position: "relative" }}
      key={columnIndex}
    >
      {isColumnRepeat || originalColumnIndex === -1 ? null : (
        <>
          <AitColumnTrafficLight cellid={cellid} />
          <AitColumnAnnotationButton
            originalColumnIndex={originalColumnIndex}
            columnId={columnId}
          />
          {state?.editable && (
            <div
              className={[styles.aitAieHolder, styles.aitColumnButtons].join(" ")}
              style={{
                display: "flex",
                justifyContent: "center",
                position: "relative",
                width: "100%",
              }}
            >
              {!(rowHeaderColumns === 1 && columnIndex === 0) &&
                !(columnIndex === rowHeaderColumns && columnIndex === maxColumnIndex) && (
                  <AitRemoveColumnButton originalColumnIndex={originalColumnIndex} />
                )}
              <AitAddColumnButton originalColumnIndex={originalColumnIndex} />
            </div>
          )}
        </>
      )}
    </td>
  );
};

AitTopBorderCell.displayName = "AitTopBorderCell";
